export const msalConfig = {
  auth: {
    clientId: "ca383e74-999b-40d8-b219-9d534b6cd41b",       // ← Id. de aplicación (cliente)
    authority: "https://login.microsoftonline.com/1b4e0e0b-e782-43bc-8986-5314dfb64c33", // ← Id. de directorio (inquilino)
    //redirectUri: "https://app.geosoftsolutions.com/", // URL de redirección (local en desarrollo)
    redirectUri: "http://localhost:3000/", // URL de redirección (local en desarrollo)
    //redirectUri: "msal36131f2b-ceed-4e07-92a1-0f9d81dfed23://auth" no sirve
  },
};

export const loginRequest = {
  scopes: ["Files.Read", "User.Read", "Sites.Selected"],
};